<template>
  <v-container>
    <v-row justify="center">
      <v-btn
        class="mx-2"
        :dark="!disabled"
        fab
        large
        color="blue darken-1"
        @click="onAdd"
        :disabled="disabled"
      >
        <v-icon dark>{{icon}}</v-icon>
      </v-btn>
    </v-row>
    <v-row justify="center">
      <v-btn text @click="onAdd" :disabled="disabled">{{label}}</v-btn>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "add-btn",
  props: {
    label: {
      type: String,
      default: () => "Add"
    },
    icon: {
      type: String,
      default: () => "mdi-plus-circle"
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },

  methods: {
    onAdd() {
      this.$emit("click");
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/AddBtn.vue